const domaines = [
    {
        title: 'ACCOMPAGNEMENT',
        description: `
             CFCAE assure une assistance complète pour l'installation d'unités industrielles ainsi que pour la mise en place et l'optimisation des processus de fabrication. |
             CFCAE conçoit des services sur mesure répondant aux besoins spécifiques de chaque client.
        `,
        color: '#fcd538'
    },
    {
        title: 'DEVELOPPEMENT',
        description: `
            <strong>Appui stratégique :</strong> Fournit un soutien stratégique pour l'obtention des agréments indispensables, tels que ceux délivrés par l'ONE, le SRM, ou toute autre entité réglementaire. |
            <strong>Assistance personnalisée :</strong> Propose un accompagnement sur mesure pour la préparation et la présentation des dossiers de financement, en tenant compte des exigences spécifiques de chaque projet. |
            <strong>Création de sites web :</strong> Offre des solutions adaptées pour la conception et le développement de sites web modernes, optimisés pour les besoins des entreprises et des projets, incluant la gestion des contenus, l'intégration des outils numériques essentiels et une expérience utilisateur fluide. Ces sites sont conçus pour valoriser vos projets auprès des investisseurs, partenaires ou clients potentiels.
        `
    },
    {
        title: 'DIAGNOSTIC',
        description: `
             CFCAE réalise l'analyse, l'identification et la résolution des problématiques techniques, organisationnelles et financières des entreprises.
        `,
        color: '#29e38d'
    },
    {
        title: 'EXPERTISE',
        description: `
             CFCAE accompagne les entreprises dans l'amélioration de la performance du personnel, de la productivité et de la rentabilité, tout en optimisant les coûts et en garantissant la qualité.
        `
    },
    {
        title: 'FORMATION',
        description: `
             CFCAE propose des formations techniques et de sécurité, incluant les bases, les audits et l'habilitation électrique, adaptées à tous les niveaux : débutant, intermédiaire et professionnel.
        `,
        color: '#520330'
    },
    {
        title: 'MEDIATION ET RECOUVREMENT',
        description: `
             CFCAE intervient dans la gestion des conflits et le recouvrement des impayés, en proposant des solutions adaptées.
        `
    }
];
export default domaines;
